export default __webpack_public_path__ + "static/media/discover.32c1bf4d.png";